"use client";

import { signIn } from "next-auth/react";

import { OIDC_PROVIDER_ID } from "@calcom/features/auth/lib/oidc/oidcProvider";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Button } from "@calcom/ui/components/button";

import { LastUsed, useLastUsed } from "@calcom/web/modules/auth/hooks/useLastUsed";

/**
 * Cyberlytics additive OIDC sign-in button (Authentik).
 * Rendered on the login page only when the AUTH_OIDC_* env gate is open.
 * Password login below it is untouched.
 */
export function OIDCLogin({
  displayName,
  callbackUrl,
  disabled,
}: {
  displayName: string;
  callbackUrl: string;
  disabled?: boolean;
}) {
  const { t } = useLocale();
  const [lastUsed, setLastUsed] = useLastUsed();

  return (
    <Button
      color="primary"
      className="justify-center w-full"
      disabled={disabled}
      data-testid="oidc"
      StartIcon="lock"
      onClick={async (e) => {
        e.preventDefault();
        setLastUsed("oidc");
        await signIn(OIDC_PROVIDER_ID, { callbackUrl });
      }}>
      <span>{t("continue_with", { appName: displayName })}</span>
      {lastUsed === "oidc" && <LastUsed />}
    </Button>
  );
}
